(function() {
  'use strict';

  angular
    .module('prodigioMobile', ['ngTouch', 'ngSanitize', 'ui.router', 'ngLodash', 'ngAnimate', 'angular-momentjs', 'ngDialog']);

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .directive('waterLevel', waterLevel);

  /** @ngInject */
  function waterLevel(sequencerService, ASSETS_PATH) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/water-level/water-level.html',
      scope: {
        autoPlay: '=autoPlay',
        onComplete: '&onComplete'
      },
      link: function (scope, elem) {
        // Load water sequence, notify directive it can be shown
        sequencerService.create(ASSETS_PATH + 'sequences/water.js', 'water', {
          width: 232,
          height: 93
        }).then(function() {
          scope.vm.sequenceLoaded = true;
        });

      },
      controller: WaterLevelController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function WaterLevelController(contentService, stateService, $timeout) {
      var vm = this;

      vm.context = {
        view: contentService.content.views.maintenance
      };

      $timeout(function () {
        angular.element('.title--water-level').removeClass('title--water-level--hidden');
        vm.onComplete();
      }, 4500)
    }
  }
})();

(function () {
    'use strict';

    angular
    .module('prodigioMobile')
    .directive('timepicker', timepicker);

    /** @ngInject */
    function timepicker($moment) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/timepicker/timepicker.html',
            scope: {
                time: '=time'
            },
            link: function (scope) {
                angular.element('.js-schedule-slider').roundSlider({
                    radius: 122,
                    min: 0,
                    startAngle: '90',
                    max: 1440,
                    handleSize: '37,37',
                    editableTooltip: false,
                    value: scope.vm.time,
                    width: 2,
                    animation: false,
                    start: function () {
                        angular.element('.section--schedule').addClass('section--schedule--active');
                    },
                    stop: function (e) {
                        angular.element('.section--schedule').removeClass('section--schedule--active');
                        scope.$evalAsync(function () {
                            scope.time = e.value;
                        });
                    },
                    tooltipFormat: function (args) {
                        var time = $moment.duration(args.value, 'minutes');
                        var hours = (time.hours() < 10 ? '0' + time.hours() : time.hours());
                        var minutes = (time.minutes() < 10 ? '0' + time.minutes() : time.minutes());
                        scope.vm.time = args.value;
                        return hours + ':' + minutes;
                    }
                });
            },
            controller: TimepickerController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    /** @ngInject */
    function TimepickerController() {
    }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .directive('sequencer', sequencer);

  /** @ngInject */
  function sequencer($timeout, sequencerService) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sequencer/sequencer.html',
      scope: {
        sequence: '@sequence',
        delay: '@delay',
        scaleable: '@scaleable',
        loop: '@loop',
        onStopped: '&onStopped'
      },
      link: SequencerLinkController,
      controller: SequencerController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SequencerController() {

    }

    function SequencerLinkController(scope, element) {
      var vm = scope.vm;
      var sequence = sequencerService.get(vm.sequence);

      vm.width = sequence.width;
      vm.height = sequence.height;

      sequence.clean(); // Always reset

      element.children().append(sequence.canvas);

      function onStopped(e) {
        // Looping, first loop
        if (vm.loop && e.detail.loops === 1) {
          if (vm.onStopped) {
            vm.onStopped();
            sequence.canvas.removeEventListener('stopped', onStopped);
          }
        }

        if (!vm.loop) {
          if (vm.onStopped) {
            vm.onStopped();
            sequence.canvas.removeEventListener('stopped', onStopped);
          }
        }
      }

      sequence.canvas.addEventListener('stopped', onStopped);

      // Play
      $timeout(function() {
        sequence.play(vm.sequence, vm.loop || false);
      }, vm.delay || 0);

      // Ensure sequence is stopped when directive is destroyed
      element.on('$destroy', function (){
        if (sequence.playing) {
          sequence.playing = false;
        }
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .directive('capsuleCounter', capsuleCounter);

  /** @ngInject */
  function capsuleCounter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/capsule-counter/capsule-counter.html',
      controller: CapsuleCounterController,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        capsuleCount: '=capsuleCount',
        autoPlay: '=autoPlay',
        delay: '@delay',
        onComplete: '&onComplete'
      }
    };

    return directive;

    /** @ngInject */
    function CapsuleCounterController(contentService, $timeout) {
      var vm = this;

      vm.context = {
        view: contentService.content.views.capsules
      };

      vm.canClick = false;

      var stopped;
      vm.play = function () {
        stopped = $timeout(function() {
           if(vm.capsuleCount > 8) {
            vm.capsuleCount = vm.capsuleCount - 1;
            vm.play();
           } else {
            vm.canClick = true;
            vm.stopCountdown();
           }

        }, 100);
      }

      if (vm.autoPlay) {
        $timeout(function() {
          vm.play();
        }, vm.delay || 0);
      }

      vm.removeCapsule = function (canClick) {
        if(canClick) {
          var value = parseInt(angular.element('.js-copy--capsule-count').text(), 10);
          if(value > 0) {
            value = value -= 1;
            angular.element('.js-copy--capsule-count').text(value--);
          } else {
            return;
          }
        }
      }

      vm.addCapsule = function (canClick) {
        if(canClick) {
          var value = parseInt(angular.element('.js-copy--capsule-count').text(), 10);
          if(value >= 0) {
            value = value += 1;
            angular.element('.js-copy--capsule-count').text(value++);
          } else {
            return;
          }
        }
      }

      vm.stopCountdown = function() {
        $timeout.cancel(stopped);
        vm.onComplete();
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .directive('preloader', preloader);

  /** @ngInject */
  function preloader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/preloader/preloader.html',
      controller: PreloaderController,
      controllerAs: 'vm',
      scope: {
      },
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function PreloaderController() {

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {},
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(stateService, contentService, $scope, $state, ngDialog) {
      var vm = this;

      vm.service = stateService;
      vm.showBackButton = vm.service.showBackButton;
      vm.isHomeBack = vm.service.isHomeback;
      vm.backUrl = vm.service.backUrl;
      vm.isScheduleBack = vm.service.isScheduleBack;

      $scope.$watch('vm.service.showBackButton', function (newVal) {
        vm.showBackButton = newVal;
      });

      $scope.$watch('vm.service.backUrl', function (newVal) {
        vm.backUrl = newVal;
      });

      $scope.$watch('vm.service.isHomeback', function (newVal) {
        vm.isHomeBack = newVal;
      });

      $scope.$watch('vm.service.isScheduleBack', function (newVal) {
        vm.isScheduleBack = newVal;
      });

      vm.openModal = function () {
        ngDialog.open({
          template: 'app/popups/machine.html',
          showClose: false,
          closeByEscape: false,
          closeByDocument: false,
          appendTo: '.section--home',
          controller: ['$scope', function() {
            // controller logic
            var vm = this;

            vm.context = {
              global: contentService.content.global
            };
          }],
          controllerAs: 'popup'
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .directive('machine', machine);

  /** @ngInject */
  function machine(sequencerService, ASSETS_PATH) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/machine/machine.html',
      scope: {
        state: '@state',
        cup: '=cup',
        onComplete: '&onComplete'
      },
      controller: MachineController,
      link: MachineLinkController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MachineController($timeout, ANIM_DUR_BREWING) {
      var vm = this;

      vm.finished = false;

      vm.play = function () {
        $timeout(function () {
          vm.onComplete();
          vm.finished = true;
        }, ANIM_DUR_BREWING[vm.cup]);
      }

      vm.play();
    }

    function MachineLinkController(scope, elem) {
      // Load brewing sequence, notify directive it can be shown
      sequencerService.create(ASSETS_PATH + 'sequences/brewing.js', 'brewing', {
        width: 146,
        height: 509
      }).then(function() {
        scope.vm.sequenceLoaded = true;
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .directive('descaling', descaling);

  /** @ngInject */
  function descaling() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/descaling/descaling.html',
      scope: {
        descalingNeeded: '=descalingNeeded'
      },
      controller: DescalingController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function DescalingController(contentService, $scope) {
      var vm = this;

      vm.context = {
        view: contentService.content.views.maintenance
      };

      $scope.$watch('vm.descalingNeeded', function() {
        if(vm.descalingNeeded) {
          //send off event to computer
        }
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .directive('coffeeCups', coffeeCups);

  /** @ngInject */
  function coffeeCups() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/coffee-cups/coffee-cups.html',
      controller: CoffeeCupsController,
      controllerAs: 'vm',
      scope: {
        selectedCup: '=selectedCup',
        onCupChange: '=onCupChange'
      },
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CoffeeCupsController(contentService) {
      var vm = this;

      vm.context = {
        global: contentService.content.global
      };

      vm.onChange = function(e) {
        if (vm.onCupChange) {
          vm.onCupChange(e)
        }
      };

      vm.cups = [
        {
          'text': vm.context.global.machine.cups.ristretto.text,
          'value': 'ristretto'
        },
        {
          'text': vm.context.global.machine.cups.espresso.text,
          'value': 'espresso'
        },
        {
          'text': vm.context.global.machine.cups.lungo.text,
          'value': 'lungo'
        }
      ];

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .service('trackingService', trackingService);

  /** @ngInject */
  function trackingService($window) {
    var log = function() {
      if (console) {
        console.log.apply(console, arguments);
      }
    };

    return {
      /**
       * Lbt is the custom tracking implementation provided by Nespresso
       * @type {Object}
       */
      lbt: {
        tracker: function() {


          // iFrame
          // Do not check if on localhost, as the ports will not match, causing a cross domain issue
          if ($window.location.hostname !== 'localhost' && $window.top && $window.top._Lbt) {
             return $window.top._Lbt;
          }
          
          // Standalone
          if ($window._Lbt) {
            return $window._Lbt;
          }

          // Development
          // return something useable and loggable!
          return {
            registerCustomAction: log,
            async: {
              track: log
            }
          }
        },
        setup: function(options) {
          if (nestms && nestms.hasOwnProperty('DataLayer') && typeof nestms.DataLayer === 'object')  {
            nestms.DataLayer.app = options;
            // TODO confirm what the below is
            // nestms.DataLayer.page.pageUid = 'landing-page:prodigio::prodigio-mobile-homepage:';
            nestms.DataLayer.products = {};
            nestms.DataLayer.error = {};
          }
        },
        register: function(action, id) {
          this.tracker().registerCustomAction(action, id);
        },
        track: function(action, id) {
          this.tracker().async.track(action, id);
        }
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .service('stateService', stateService);

  /** @ngInject */
  function stateService() {
    return {
      isMachineFound: false,
      showBackButton: false,
      isHomeback: true,
      isScheduleBack: false
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .service('sequencerService', sequencerService);

  /** @ngInject */
  function sequencerService($q, lodash) {

    function createSequence(src, name, opts) {
      var options = opts;
      var deferred = $q.defer();
      var canvas = document.createElement('canvas');
      var sequencer;

      if (options.width) {
        canvas.width = options.width;
      }

      if (options.height) {
        canvas.height = options.height;
      }

      sequencer = new Sequencer({
          fps : options.fps || 25,
          canvas : canvas,
          width: options.width || false,
          height: options.height  || false
      });

      sequencer.canvas.addEventListener('loaded', function(){
        deferred.resolve({
          name: name,
          sequencer: sequencer
        });
      });

      sequencer.loadSequence(name, src);

      return deferred.promise;
    }

    return {
      sequences: [],
      /**
       * Create a sequence, which is then stored in the service
       * @param  {String} src  Path to sequence
       * @param  {String} name Name of sequence
       * @param  {Object} opts Specific options to create sequence with
       * @return {Promise}
       */
      create: function(src, name, opts) {
        var _this = this;

        return createSequence(src, name, opts)
          .then(function(sequence) {
            _this.sequences.push(sequence);
          });
      },
      get: function(name) {
        return lodash.find(this.sequences, { name: name }).sequencer;
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .service('eventsService', eventsService);

  /** @ngInject */
  function eventsService($http, $q, $timeout, lodash, ENDPOINTS, DISABLE_EVENTS) {
    /**
     * Private variables
     */
    var subscribeDeferred = $q.defer(); // Allow events to wait for subscribe to finish
    var sessionId = undefined;

    /**
     * Put state to server
     * @param  {String} id The session ID
     * @return {Promise}
     */
    var putState = function(payload) {
      var deferred = $q.defer();

      // Events may fire before we are subscribed; defer
      // these until it's complete
      if (!getSessionId()) {
        return $q.all([subscribeDeferred.promise]).then(function() {
          putState(payload);
        });
      }

      $http({
        url: ENDPOINTS.api,
        params: {
          id: getSessionId()
        },
        data: JSON.stringify(payload),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(function(response) {
        // Resolve with data
        deferred.resolve(response.data);
      }).catch(function(e) {
        deferred.reject(e);
      });

      return deferred.promise;
    };

    /**
     * Getter for session ID
     * @return {Promise} Resolves with session ID, rejects with event
     */
    var getSessionId = function() {
      return sessionId;
    };
    /**
     * Setter for session ID
     * @param {String} id Channel ID
     */
    var setSessionId = function(id) {
      var deferred = $q.defer();

      if (!id) {
        deferred.reject({'error': 'No ID'});
      }

      $http({
        url: ENDPOINTS.api,
        params: {
          id: id.toUpperCase()
        },
        method: 'GET'
      }).then(function(response) {
        if (response.data.error) {
          sessionId = undefined;
          deferred.reject(response.data);
        } else {
          // Set id
          sessionId = id;
          // Resolve with session ID
          deferred.resolve(id);
        }
      }).catch(function(e) {
        sessionId = undefined;
        deferred.reject(e);
      });

      return deferred.promise;
    };

    /**
     * Service
     */
    return {
      subscribe: function(id) {
        // Always reset promise
        subscribeDeferred = $q.defer();

        if (!id) {
          subscribeDeferred.reject({'error': 'No ID'});
        }

        if (DISABLE_EVENTS) {
          subscribeDeferred.resolve();
        }

        setSessionId(id)
          .then(function(d) {
            subscribeDeferred.resolve(d);
          })
          .catch(function(error) {
            subscribeDeferred.reject(error);
          });

        return subscribeDeferred.promise;
      },
      trigger: function(obj) {
        var deferred = $q.defer();
        var data = lodash.defaults({}, obj, {
          'machine': ''
        });

        if (DISABLE_EVENTS) {
          deferred.resolve();
        }

        //
        if (!data.state) {
          deferred.reject({ 'error': 'State not defined' });
        }

        putState(data)
          .then(function() {
            deferred.resolve();
          })
          .catch(function(e) {
            deferred.reject(e);
          })

        return deferred.promise;
      },
      isSubscribed: function() {
        return getSessionId();
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .service('contentService', contentService);

  /** @ngInject */
  function contentService($http, $q, CONTENT_PATH) {
    return {
      content: null,

      checkLocaleSetting: function(value) {
        var setting = this.content.global.locale_settings['locale_settings_' + value];

        if (!setting) {
          return false;
        }

        if (setting.text === 'locale_settings_' + value + '_true') {
          return true;
        } else {
          return false;
        }
      },

      load: function(opts) {
        var _this = this;
        var options = opts || {};
        var deferred = $q.defer();
        var filename = options.lang && options.region ? options.lang + '_' + options.region : 'en_uk';

        $http({
          url: CONTENT_PATH + filename + '.json',
          method: 'GET'
        }).then(function(response) {
          // Set content
          _this.content = response.data;
          // Resolve with service
          deferred.resolve(_this);
        }).catch(function(e) {
          // Caught by '$stateChangeError'
          deferred.reject(e);
        });

        return deferred.promise;
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('ScheduleSetController', ScheduleSetController);

  /** @ngInject */
  function ScheduleSetController(contentService, eventsService, stateService, $state, $stateParams, $moment) {
    var vm = this;

    // Protect route if no code
    if (!eventsService.isSubscribed()) {
      return $state.go('app.code');
    }

    vm.context = {
      global: contentService.content.global,
      view: contentService.content.views.schedule
    };


    vm.cup = $stateParams.cup ? $stateParams.cup : 'ristretto';
    vm.time = $stateParams.time ? $stateParams.time : 397;

    // Trigger state
    eventsService.trigger({
      'state': 'scheduleBrew',
      'machine': vm.cup
    });

    var scheduleTimeMinutes = $moment.duration(vm.time, 'minutes');
    var hours = (scheduleTimeMinutes.hours() < 10 ? '0' + scheduleTimeMinutes.hours() : scheduleTimeMinutes.hours());
    var minutes = (scheduleTimeMinutes.minutes() < 10 ? '0' + scheduleTimeMinutes.minutes() : scheduleTimeMinutes.minutes());

    vm.formattedTime = hours + ':' + minutes;

    stateService.showBackButton = true;
    stateService.isHomeback = false;
    stateService.isScheduleBack = true;
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('ScheduleController', ScheduleController);

  /** @ngInject */
  function ScheduleController(contentService, eventsService, stateService, $state, $stateParams, $moment) {
    var vm = this;

    // Protect route if no code
    if (!eventsService.isSubscribed()) {
      return $state.go('app.code');
    }

    vm.context = {
      global: contentService.content.global,
      view: contentService.content.views.schedule
    };

    vm.cup = $stateParams.cup;
    var date = new Date();
    vm.time = $stateParams.time ? $stateParams.time : Math.floor(($moment.duration(date)._milliseconds / 1000) / 60);

    // Trigger state
    eventsService.trigger({
      'state': 'setSchedule',
      'machine': vm.cup
    });

    vm.onCupChange = function(cup) {
      // Trigger state
      eventsService.trigger({
        'state': 'setSchedule',
        'machine': cup
      });
    };

    vm.goToScheduleSet = function (time, cup) {
      if(cup) {
        $state.go('app.setSchedule', {time: time, cup: cup});
      }
    }

    stateService.showBackButton = true;
    stateService.isHomeback = true;
    stateService.isScheduleBack = false;
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('MaintenanceSetController', MaintenanceSetController);

  /** @ngInject */
  function MaintenanceSetController(contentService, eventsService, stateService, $scope, $timeout, $state) {
    var vm = this;

    // Protect route if no code
    if (!eventsService.isSubscribed()) {
      return $state.go('app.code');
    }

    vm.context = {
      global: contentService.content.global,
      view: contentService.content.views.maintenance
    };

    // As no `back` text was in json so had to access another way
    vm.backBtn = contentService.content.views;

    stateService.showBackButton = true;
    stateService.isHomeback = true;
    stateService.isScheduleBack = false;

    // Trigger state
    eventsService.trigger({
      'state': 'waterStatus'
    });

    vm.descalingNeeded = false;

    vm.finished = function () {
      $timeout(function() {
        $scope.$apply(function() {
          vm.descalingNeeded = true;
          // Trigger state
          eventsService.trigger({
            'state': 'descaling'
          });
        });
      }, 2000);
      // send something to descaling directive to chane text

      vm.waterAnimationComplete = function () {
        eventsService.trigger({
          'state': 'myProdigio',
          'machine': ''
        });

        $state.go('app.home');
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController(contentService, eventsService, stateService, $state, ngDialog) {
    var vm = this;

    if (!eventsService.isSubscribed()) {
      return $state.go('app.code');
    }

    if (!stateService.isMachineFound) {
      return $state.go('app.connectivity');
    }

    vm.context = {
      global: contentService.content.global,
      view: contentService.content.views.home
    };

    vm.machineImage = './assets/img/machine-default.png';

    vm.openModal = function () {
      ngDialog.open({
        template: 'app/popups/machine.html',
        showClose: false,
        closeByEscape: false,
        closeByDocument: false,
        appendTo: '.section--home',
        controller: ['$scope', function() {
          // controller logic
          var vm = this;

          vm.context = {
            global: contentService.content.global
          };
        }],
        controllerAs: 'popup'
      });
    }

    stateService.showBackButton = false;

    eventsService.trigger({
      'state': 'myProdigio'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('ConnectivityController', ConnectivityController);

  /** @ngInject */
  function ConnectivityController(contentService, eventsService, stateService, $timeout, $state) {
    var vm = this;

    // Protect route if no code
    if (!eventsService.isSubscribed()) {
      return $state.go('app.code');
    }

    vm.context = {
      view: contentService.content.views.finding
    };

    eventsService.trigger({
      'state': 'findingMachine'
    });

    $timeout(function () {
      stateService.isMachineFound = true;

      $state.go('app.home');
    }, 8000);
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('CodeController', CodeController);

  /** @ngInject */
  function CodeController(contentService, eventsService, $scope, $state, $stateParams) {
    var vm = this;

    vm.context = {
      view: contentService.content.views.code
    };

    vm.invalid = false;
    var codeLength = 5;
    vm.id = $stateParams.id ? ($stateParams.id.length === codeLength ? $stateParams.id : addToId($stateParams.id, codeLength)) : new Array(codeLength);

    function addToId(id, codeLength) {
      var currentCodeLength = id.length;
      var codeArray = id.split('');
      for(var i = currentCodeLength; i < codeLength; i++) {
        codeArray.push('');
      }

      return codeArray;
    }

    vm.codeFocus = function (event) {
      if(event.keyCode === 9 || event.keyCode === 16) return;
      var elem = angular.element(event.currentTarget);
      var regex = /^[a-zA-Z0-9]/;
      var value = elem.val();
      var shortString = value.substring(0,1);

      if(!elem.hasClass('.code-character--last')) {
        if(regex.test(value)) {
          elem.parent().next().children('.code-character').click().focus();
        }
      }
    }


    vm.subscribe = function() {
      var sessionId = vm.id.join('');

      eventsService.subscribe(sessionId)
        .then(function() {
          $state.go('app.home');
        })
        .catch(function() {
          $scope.$evalAsync(function(){
            vm.invalid = true;
          });
        })
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('CapsulesController', CapsulesController);

  /** @ngInject */
  function CapsulesController(contentService, eventsService, stateService, $state, ngDialog) {
    var vm = this;

    // Protect route if no code
    if (!eventsService.isSubscribed()) {
      return $state.go('app.code');
    }

    vm.context = {
      global: contentService.content.global,
      view: contentService.content.views.capsules
    };

    // Trigger state
    eventsService.trigger({
      'state': 'capsulesStatus'
    });

    stateService.showBackButton = true;
    stateService.isHomeback = true;
    stateService.isScheduleBack = false;

    vm.capsuleCount = 68;

    vm.capsuleCountClickComplete = function () {
      // Trigger state
      eventsService.trigger({
        'state': 'myProdigio',
        'machine': ''
      });

      $state.go('app.home');
    }

    vm.openModal = function () {
      var dialog = ngDialog.open({
        template: 'app/popups/machine.html',
        showClose: false,
        closeByEscape: false,
        closeByDocument: false,
        appendTo: '.section--capsules',
        controller: ['$scope', function() {
          // controller logic
          var vm = this;

          vm.context = {
            global: contentService.content.global
          };

        }],
        controllerAs: 'popup'
      });

      dialog.closePromise.then(function () {
        vm.capsuleCountClickComplete();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('BrewingController', BrewingController);

  /** @ngInject */
  function BrewingController($stateParams, $state, contentService, stateService, eventsService) {
    var vm = this;

    // Protect route if no code
    if (!eventsService.isSubscribed()) {
      return $state.go('app.code');
    }

    vm.context = {
      global: contentService.content.global,
      view: contentService.content.views.brew
    };

    vm.cup = $stateParams.cup;

    // Trigger state
    eventsService.trigger({
      'state': 'brewing',
      'machine': $stateParams.cup
    });

    vm.machineImage = './assets/img/machine-brewing.png';
    vm.machineImageBrewed = './assets/img/machine-brewing-' + $stateParams.cup + '.png';

    vm.brewingCompleted = function () {
      vm.finished = true;
    }

    stateService.showBackButton = false;

    vm.finishedBrewing = function () {
      // Trigger state
      eventsService.trigger({
        'state': 'myProdigio'
      });

      $state.go('app.home');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('BrewController', BrewController);

  /** @ngInject */
  function BrewController(contentService, stateService, eventsService, $state) {
    var vm = this;

    // Protect route if no code
    if (!eventsService.isSubscribed()) {
      return $state.go('app.code');
    }

    vm.context = {
      global: contentService.content.global,
      view: contentService.content.views.brew
    };

    vm.machineImage = './assets/img/machine-default.png';

    // Trigger state
    eventsService.trigger({
      'state': 'brewNow',
      'machine': 'ristretto'
    });

    vm.onCupChange = function(cup) {
      // Trigger state
      eventsService.trigger({
        'state': 'brewNow',
        'machine': cup
      });
    }

    vm.goToBrewing = function (cup) {
      if(cup) {
        $state.go('app.brewing', {cup: cup});
      }
    }

    stateService.showBackButton = true;
    stateService.isHomeback = true;
    stateService.isScheduleBack = false;
  }
})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $state, $window, eventsService) {
    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams) { //eslint-disable-line
      // console.log(event, toState, toParams, fromState, fromParams);
    });

    $rootScope.$on("$stateChangeSuccess", function () { //eslint-disable-line
        $window.scrollTo(0, 0);
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, REGION_DEFAULT, LANG_DEFAULT) {
    $stateProvider
      .state('app', {
        url: '/:lang/:region?code',
        templateUrl: 'app/index.html',
        abstract: true,
        controller: 'IndexController',
        controllerAs: 'index',
        resolve: {
          content: function(contentService, $stateParams) {
            return contentService.load({
              lang: $stateParams.lang,
              region: $stateParams.region
            });
          }
        }
      })
        .state('app.home', {
          url: '',
          templateUrl: 'app/home/home.html',
          controller: 'HomeController',
          controllerAs: 'home'
        })
        .state('app.connectivity', {
          url: '/connectivity',
          templateUrl: 'app/connectivity/connectivity.html',
          controller: 'ConnectivityController',
          controllerAs: 'connect'
        })
        .state('app.code', {
          url: '/code',
          templateUrl: 'app/code/code.html',
          controller: 'CodeController',
          controllerAs: 'code'
        })
        .state('app.brew', {
          url: '/brew',
          templateUrl: 'app/brew/brew.html',
          controller: 'BrewController',
          controllerAs: 'brew'
        })
        .state('app.brewing', {
          url: '/brew/brewing',
          templateUrl: 'app/brewing/brewing.html',
          controller: 'BrewingController',
          controllerAs: 'brewing',
          params: {
            cup: null
          }
        })
        .state('app.schedule', {
          url: '/schedule',
          templateUrl: 'app/schedule/schedule.html',
          controller: 'ScheduleController',
          controllerAs: 'schedule',
          params: {
            time: null,
            cup: null
          }
        })
        .state('app.setSchedule', {
          url: '/schedule/set',
          templateUrl: 'app/schedule-set/schedule-set.html',
          controller: 'ScheduleSetController',
          controllerAs: 'scheduleSet',
          params: {
            time: null,
            cup: null
          }
        })
        .state('app.capsules', {
          url: '/capsules',
          templateUrl: 'app/capsules/capsules.html',
          controller: 'CapsulesController',
          controllerAs: 'capsules'
        })
        .state('app.maintenance', {
          url: '/maintenance',
          templateUrl: 'app/maintenance/maintenance.html',
          controller: 'MaintenanceSetController',
          controllerAs: 'maintenance'
        })

      $urlRouterProvider.otherwise('/' + LANG_DEFAULT + '/' + REGION_DEFAULT);

      $urlRouterProvider.when('/:lang/:region/', '/:lang/:region');
  }

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(eventsService, stateService, trackingService, $stateParams, $state, $scope) {
    var vm = this;

    vm.isMachineFound = stateService.isMachineFound;

    vm.service = stateService;

    $scope.$watch('vm.service.isMachineFound', function (newVal) {
      vm.isMachineFound = newVal;
    });

    vm.location = 'location--' + $stateParams.lang + '-' + $stateParams.region;

    if ($stateParams.code) {
      eventsService.subscribe($stateParams.code)
        .then(function() {
          $state.go('app.connectivity');
        })
        .catch(function() {
          $state.go('app.code');
        })
    } else {
      $state.go('app.code');
    }

    // Setup tracking
    // TODO confirm this for mobile controller
    // trackingService.lbt.setup({
    //   'version':  'stand-alone',
    //   'platform': 'm-site',
    //   'release': '1',
    //   'country': $stateParams.region.toUpperCase(),
    //   'language': $stateParams.lang,
    //   'channel': 'B2C'
    // });

    // Register tracking events
    //trackingService.lbt.register({ eventName: 'pageViewDynamic', eventType: 'click' }, 'pageView');
  }
})();

angular.module("prodigioMobile")

.constant("DISABLE_EVENTS", false)

.constant("ASSETS_PATH", "./assets/")

.constant("CONTENT_PATH", "./assets/content/")

.constant("ENDPOINTS", {
	"api": "../../prodigio/backoffice/"
})

.constant("DTM_SCRIPT_PATH", "//www.nespresso.com/dtm/prod/2016687db8840fa748bbdc966b49915a93243a15/satelliteLib-7534d9ec2b2d1c92a804f9e1163a0d6f4ae90ac1.js")

;
(function() {
  'use strict';

  angular
    .module('prodigioMobile')
      // Content
      .constant('REGION_DEFAULT', 'uk')
      .constant('LANG_DEFAULT', 'en')
      // Animations
      .constant('ANIM_DUR_BREWING', {
        ristretto: 8000,
        espresso: 8000,
        lungo: 8000
      });

})();

(function() {
  'use strict';

  angular
    .module('prodigioMobile')
    .config(config);

  /** @ngInject */
  function config($urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.strictMode(false);
  }

})();

angular.module("prodigioMobile").run(["$templateCache", function($templateCache) {$templateCache.put("app/index.html","<navbar ng-if=\"index.service.isMachineFound\"></navbar><div data-anim-sync=\"true\" class=\"content view-slide-in\" ng-class=\"index.location\" ui-view=\"\"></div>");
$templateCache.put("app/brewing/brewing.html","<section class=\"section section--brewing\"><div class=\"container container--brewing\"><machine state=\"brewing\" on-complete=\"brewing.brewingCompleted()\" cup=\"brewing.cup\"></machine><h1 class=\"title title--brewing\">{{brewing.context.view.action_overlays.brewing.heading.text}}</h1><h2 class=\"sub-title\">{{brewing.context.view.action_overlays.brewing.info.heading.text}}</h2><p class=\"copy\" ng-bind-html=\"::brewing.context.view.action_overlays.brewing.info.copy.text\"></p><a href=\"\" class=\"btn-primary btn-primary--spacer\" ng-if=\"brewing.finished\" ng-click=\"brewing.finishedBrewing()\">{{brewing.context.view.action_overlays.brewing.btn_finish.text}}</a></div></section>");
$templateCache.put("app/brew/brew.html","<section class=\"section\"><div class=\"container\"><machine state=\"myProdigio\"></machine><h1 class=\"title\" ng-bind-html=\"::brew.context.view.select_cup.heading.text\"></h1><coffee-cups class=\"coffee-cup-container\" selected-cup=\"brew.cup\" on-cup-change=\"brew.onCupChange\"></coffee-cups><a href=\"\" class=\"btn-primary btn-primary--spacer\" ng-click=\"brew.goToBrewing(brew.cup)\" ng-class=\"{\'btn-primary--disabled\': !brew.cup}\" ng-bind-html=\"::brew.context.view.select_cup.btn_start.text\"></a></div></section>");
$templateCache.put("app/capsules/capsules.html","<section class=\"section section--capsules\"><div class=\"container\"><h1 class=\"title title--capusles\" ng-bind-html=\"::capsules.context.view.heading.text\"></h1><capsule-counter capsule-count=\"capsules.capsuleCount\" auto-play=\"true\" delay=\"1000\" on-complete=\"capsules.capsuleCountComplete()\"></capsule-counter><ul class=\"menu menu--capsules\"><li><a href=\"\" ng-click=\"capsules.openModal()\" class=\"btn-success btn-success--last-order\"><span class=\"icon-nespresso-bag icon-nespresso-bag--success-btn\"></span> <span ng-bind-html=\"::capsules.context.view.capsule_counter.btn_last_order.text\"></span></a></li><li><a href=\"\" ng-click=\"capsules.openModal()\" class=\"btn-success btn-success--no-margin\"><span class=\"icon-capsule icon-capsule--success-btn\"></span> <span ng-bind-html=\"::capsules.context.view.capsule_counter.btn_place_order.text\"></span></a></li></ul></div></section>");
$templateCache.put("app/code/code.html","<section class=\"section section--code\"><form ng-submit=\"code.subscribe(code.id)\"><div class=\"form__fields\"><div class=\"form__control\" ng-class=\"{\'form__control--first\':$first}\" ng-repeat=\"codeInput in code.id track by $index\"><input class=\"code-character\" ng-class=\"{\'code-character--last\':$last}\" ng-keyup=\"code.codeFocus($event)\" type=\"text\" ng-model=\"code.id[$index]\" maxlength=\"1\" minlength=\"1\" value=\"code.id[$index]\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\"></div></div><p ng-if=\"code.invalid\" class=\"copy\">Please enter a valid code</p><button type=\"submit\" class=\"form__submit btn-circle\">{{code.context.view.btn_start_now.text}} <span class=\"icon-start-now\"></span></button></form><p class=\"copy copy--footer\" ng-bind-html=\"::code.context.view.copy_footer.text\"></p></section>");
$templateCache.put("app/popups/machine.html","<h1 class=\"title title--popup\" ng-bind-html=\"::popup.context.global.overlays.error.feature_unavailable.copy.text\"></h1><a href=\"\" ng-click=\"closeThisDialog()\" class=\"btn-default btn-default--popup\" ng-bind-html=\"::popup.context.global.overlays.error.feature_unavailable.btn_ok\"></a>");
$templateCache.put("app/connectivity/connectivity.html","<section class=\"section section--no-header\"><div class=\"container container--content\"><preloader></preloader><h1 class=\"title title--connectivity\" ng-bind-html=\"::connect.context.view.heading.text\"></h1><p class=\"copy copy--connectivity\" ng-bind-html=\"::connect.context.view.copy_wait.text\"></p></div></section>");
$templateCache.put("app/home/home.html","<section class=\"section section--home\"><div class=\"container container--content\"><machine state=\"myProdigio\"></machine><h1 class=\"title\" ng-bind-html=\"::home.context.global.machine.name.text\"></h1><div class=\"menu-container\"><ul class=\"menu menu--home\"><li class=\"menu__item menu__item--home\" ng-class=\"{\'menu__item--home-first\' : $index === 0}\" ng-repeat=\"item in home.context.view.menu_primary\"><a class=\"menu__link menu__link--home\" ui-sref=\"app.{{::item.view}}\"><span class=\"menu__icon icon-coffee-cup\" ng-if=\"::item.view === \'brew\'\"></span> <span class=\"menu__icon icon-schedule\" ng-if=\"::item.view === \'schedule\'\"></span> <span ng-bind-html=\"::item.text\"></span></a></li></ul></div><ul class=\"menu menu--machine\"><li class=\"menu__item menu__item--machine\" ng-repeat=\"item in home.context.view.menu_secondary\"><a class=\"menu__link menu__link--machine menu__link--machine-status\" ng-if=\"$index === 0\" ng-click=\"home.openModal()\" href=\"\"><span class=\"icon-cog\"></span></a> <a class=\"menu__link menu__link--machine\" ng-if=\"item.view === \'capsules\'\" ui-sref=\"app.{{::item.view}}\"><span class=\"icon-capsule icon-capsule--home\"></span></a> <a class=\"menu__link menu__link--machine\" ng-if=\"item.view === \'maintenance\'\" ui-sref=\"app.{{::item.view}}\"><span class=\"icon-droplet\"></span></a><p class=\"menu__link-text\" ng-if=\"$index === 0\">{{::item.text}} <span class=\"machine__value machine__value--machine\">{{home.context.global.machine.status.machine.text}}</span></p><p class=\"menu__link-text\" ng-if=\"item.view === \'capsules\'\">{{::item.text}} <span class=\"machine__value machine__value--capsules\">68</span></p><p class=\"menu__link-text\" ng-if=\"item.view === \'maintenance\'\">{{::item.text}} <span class=\"machine__value machine__value--maintenance\">{{home.context.global.machine.status.water.text}}</span></p></li></ul></div></section>");
$templateCache.put("app/maintenance/maintenance.html","<section class=\"section section--maintenance\"><div class=\"container\"><h1 class=\"title title--maintenance\" ng-bind-html=\"::maintenance.context.view.heading.text\"></h1><div class=\"row\"><water-level auto-play=\"true\" on-complete=\"maintenance.finished()\"></water-level></div><descaling descaling-needed=\"maintenance.descalingNeeded\"></descaling></div></section>");
$templateCache.put("app/schedule/schedule.html","<section class=\"section section--schedule\"><div class=\"container\"><timepicker time=\"schedule.time\"></timepicker><coffee-cups class=\"coffee-cup-container coffee-cup-container--schedule\" selected-cup=\"schedule.cup\" on-cup-change=\"schedule.onCupChange\"></coffee-cups><a href=\"\" class=\"btn-primary btn-primary--spacer\" ng-click=\"schedule.goToScheduleSet(schedule.time, schedule.cup)\" ng-class=\"{\'btn-primary--disabled\': !schedule.cup}\" ng-bind-html=\"::schedule.context.view.select_cup.btn_start.text\"></a></div></section>");
$templateCache.put("app/schedule-set/schedule-set.html","<section class=\"section section--schedule-set\"><div class=\"container\"><div class=\"scheduled-brew\"><span class=\"icon-espresso icon-espresso--schedule-set\"></span><p class=\"scheduled-brew__time\">{{scheduleSet.formattedTime}}</p><span class=\"icon-sun icon-sun--schedule-set\"></span></div><h1 class=\"title title--schedule-set\" ng-bind-html=\"::scheduleSet.context.view.subviews.scheduled.subheading.text\"></h1><ul class=\"menu menu--schedule-set\"><li class=\"menu--schedule-set__item menu--schedule-set__item--first\"><a class=\"btn-default\" ui-sref=\"app.home\">{{::scheduleSet.context.view.subviews.scheduled.btn_delete.text}}</a></li><li class=\"menu--schedule-set__item\"><a class=\"btn-default\" ui-sref=\"app.schedule({time: scheduleSet.time, cup: scheduleSet.cup})\">{{::scheduleSet.context.view.subviews.scheduled.btn_edit.text}}</a></li></ul><p class=\"copy copy--schedule-set\" ng-bind-html=\"::scheduleSet.context.view.subviews.scheduled.copy.text\"></p><a href=\"\" class=\"btn-primary btn-primary--spacer\" ui-sref=\"app.brewing({cup: scheduleSet.cup})\" ng-bind-html=\"::scheduleSet.context.view.subviews.scheduled.btn_back.text\"></a></div></section>");
$templateCache.put("app/components/capsule-counter/capsule-counter.html","<div class=\"capsule-counter\"><a ng-click=\"vm.removeCapsule(vm.canClick)\" class=\"capsule-icon icon-minus\" ng-class=\"{\'capsule-icon--clickable\': vm.canClick}\"></a> <a ng-click=\"vm.addCapsule(vm.canClick)\" class=\"capsule-icon icon-plus\" ng-class=\"{\'capsule-icon--clickable\': vm.canClick}\"></a><p class=\"copy copy--capsule-count js-copy--capsule-count\" ng-model=\"vm.capsuleCount\">{{vm.capsuleCount}}</p><p class=\"copy copy--capsules-left-text\" ng-bind-html=\"::vm.context.view.capsule_counter.copy_capsules_left.text\"></p><p class=\"copy copy--consumption-text\" ng-bind-html=\"::vm.context.view.capsule_counter.copy_estimate.text\"></p></div>");
$templateCache.put("app/components/machine/machine.html","<div class=\"machine-image\"><div class=\"machine-image__inner\"><div class=\"machine-default\"><img ng-if=\"vm.state === \'myProdigio\'\" class=\"machine-image__image machine-image__image--default\" src=\"./assets/img/machine-default.png\"></div><div class=\"machine-brewing\" ng-if=\"vm.state === \'brewing\'\"><img ng-if=\"vm.cup === \'ristretto\' || vm.cup === \'espresso\'\" class=\"machine-brewing-cup\" src=\"./assets/img/machine-cup-empty-small.png\"> <img ng-if=\"vm.cup === \'lungo\'\" class=\"machine-brewing-cup machine-brewing-cup--large\" src=\"./assets/img/machine-cup-empty-large.png\"><div class=\"machine-brewing-sequence-mask\"><div ng-if=\"vm.state === \'brewing\'\" class=\"machine-brewing-sequence\" ng-class=\"\'machine-brewing-sequence--\' + vm.cup\"><sequencer ng-if=\"vm.sequenceLoaded\" sequence=\"brewing\" scaleable=\"true\" delay=\"2250\" on-stopped=\"vm.onComplete()\"></sequencer></div></div></div></div></div>");
$templateCache.put("app/components/descaling/descaling.html","<table class=\"table\"><tr class=\"table__row\"><th class=\"table__head\">{{vm.context.view.descaling.copy_descaling.text}}</th><td class=\"table__cell\" ng-if=\"vm.descalingNeeded\"><p class=\"table__text\"><span class=\"table__text--descaling-needed\">{{vm.context.view.descaling.copy_descaling_needed.text}}</span> <span class=\"icon-arrow-right\"></span></p></td><td class=\"table__cell table__cell--info\" ng-if=\"!vm.descalingNeeded\"><p class=\"table__text\"><span>{{vm.context.view.descaling.copy_descaling_not_needed.text}}</span> <span class=\"icon-arrow-right\"></span></p></td></tr><tr class=\"table__row\"><th class=\"table__head\">{{vm.context.view.descaling.copy_water_hardness.text}}</th><td class=\"table__cell table__cell-info\"><p class=\"table__text\">{{vm.context.view.descaling.copy_water_hardness_level.text}} <span class=\"icon-arrow-right\"></span></p></td></tr></table>");
$templateCache.put("app/components/coffee-cups/coffee-cups.html","<form class=\"coffee-cups\"><div class=\"coffee-cup\" ng-class=\"{\'coffee-cup--first\':$first, \'coffee-cup--last\':$last}\" ng-repeat=\"item in vm.cups\"><input class=\"coffee-cup__radio-btn\" id=\"{{item.value}}\" type=\"radio\" name=\"cup-size\" ng-model=\"vm.selectedCup\" ng-change=\"vm.onChange(item.value)\" value=\"{{item.value}}\"> <label class=\"coffee-cup__label\" for=\"{{item.value}}\"><span class=\"coffee-cup__icon\"><span class=\"cup-icon cup-icon--{{item.value}} icon-{{item.value}}\"></span></span> <span ng-bind-html=\"item.text\"></span></label></div></form>");
$templateCache.put("app/components/timepicker/timepicker.html","<div class=\"schedule-container\"><div class=\"timepicker-dots\"></div><div class=\"js-schedule-slider schedule-slider\"></div><span class=\"icon-sun\"></span></div>");
$templateCache.put("app/components/navbar/navbar.html","<div class=\"navbar\"><a ui-sref=\"app.home\" ng-if=\"vm.showBackButton && vm.isHomeBack\" class=\"icon-back-btn navbar__back-btn\"></a> <a ui-sref=\"app.schedule\" ng-if=\"vm.showBackButton && vm.isScheduleBack\" class=\"icon-back-btn navbar__back-btn\"></a> <span class=\"icon-logo navbar__icon--logo\"></span> <a href=\"\" ng-click=\"vm.openModal()\" class=\"icon-nespresso-bag navbar__icon--bag\"></a></div>");
$templateCache.put("app/components/water-level/water-level.html","<div class=\"water-level\"><div class=\"water-level__scale\"></div><sequencer ng-if=\"vm.sequenceLoaded\" sequence=\"water\" loop=\"true\" scaleable=\"true\" on-stopped=\"vm.sequenceFinished()\"></sequencer></div><div class=\"water-level__container\"><p class=\"title title--water-level title--water-level--hidden\" ng-bind-html=\"::vm.context.view.water_level.copy_status_ok.text\"></p><p class=\"copy copy--water-quality\" ng-bind-html=\"::vm.context.view.water_level.copy_info.text\"></p></div>");
$templateCache.put("app/components/preloader/preloader.html","<div class=\"finding-machine\"><div class=\"finding-machine__radar\"></div><div class=\"finding-machine__mobile\"></div></div>");
$templateCache.put("app/components/sequencer/sequencer.html","<div class=\"b-sequencer\" ng-class=\"{ \'b-sequencer--scaleable\': vm.scaleable }\" ng-style=\"{ width: vm.width, height: vm.height }\"></div>");}]);